import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { content } from "../data/content";
import { ArrowDown } from "lucide-react";

const Hero = () => {
  const { lang } = useLanguage();
  const t = content[lang].hero;

  const scrollToProjects = () => {
    const projectsSection = document.getElementById('projects');
    if (projectsSection) {
        projectsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 md:py-32">
      <div className="max-w-4xl mx-auto px-6">
        <div className="flex flex-col-reverse md:flex-row md:items-start md:justify-between gap-12">
            
            <div className="flex flex-col gap-8 flex-1">
                {/* Minimal Status Badge */}
                <div className="flex items-center gap-2 text-sm font-medium text-muted-foreground mb-4">
                     <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
                     {t.status}
                </div>

                {/* Main Typographic lockup */}
                <div className="space-y-4">
                    <h1 className="text-4xl md:text-6xl font-bold tracking-tight text-foreground">
                        {t.name}
                    </h1>
                    <h2 className="text-2xl md:text-4xl font-medium text-muted-foreground">
                        {t.role}
                    </h2>
                </div>
                
                {/* Description & Highlight */}
                <div className="max-w-2xl mt-4">
                     <p className="text-xl md:text-2xl text-foreground/90 leading-relaxed font-light">
                        {t.headline}
                     </p>
                     <p className="mt-6 text-lg text-muted-foreground leading-relaxed">
                        {t.desc}
                     </p>
                </div>

                {/* Subtle Scroll Indicator */}
                <button 
                    onClick={scrollToProjects}
                    className="mt-8 flex items-center gap-2 text-sm text-muted-foreground/50 animate-bounce hover:text-foreground transition-colors cursor-pointer"
                >
                    <ArrowDown className="w-4 h-4" />
                    {t.cta}
                </button>
            </div>

            {/* Profile Image */}
            <div className="shrink-0 relative">
                <div className="w-48 h-48 md:w-64 md:h-64 rounded-2xl overflow-hidden border border-border/50 bg-secondary/20 shadow-xl rotate-3 hover:rotate-0 transition-transform duration-500 ease-out">
                    <img 
                        src="/profile.webp" 
                        alt={t.name}
                        className="w-full h-full object-cover"
                    />
                </div>
                {/* Decorative element */}
                <div className="absolute -inset-4 bg-gradient-to-tr from-primary/20 to-transparent blur-2xl -z-10 opacity-50" />
            </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;
